import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const pet_name = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('pet_name')]:
        BaseSchema_PetHealthV1GetsafeDe.shape.pet_name.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_name.title',
        },
      },
      {
        type: 'input',
        shouldTrackValues: true,
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_name.label',
        },
        name: params.helperFunctions.getParamPath('pet_name'),
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'pet_type',
  }) as const satisfies AnyStepConfiguration

export default pet_name
